import { useQuery } from '@apollo/client';
import { GetParcelDataAndPropertyContactsByApnQuery } from '../../api/ariadne/__generated_types__/graphql';
import GET_PARCEL_DATA_AND_PROPERTY_CONTACTS_BY_APN from '../../api/ariadne/queries/get-parcel-data-and-property-contacts-by-apn';

export function useApnData(name: string, apn?: string) {
  return useQuery<GetParcelDataAndPropertyContactsByApnQuery>(
    GET_PARCEL_DATA_AND_PROPERTY_CONTACTS_BY_APN,
    {
      variables: {
        apn,
        regionId: name,
      },
      skip: !apn,
    }
  );
}
